module.exports = __webpack_public_path__ + "img/ball.b23a297c.png";